module.exports = __webpack_public_path__ + "html/week5_35c5f9c4744070576482054f3f6ee6d8.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week5.html
// module id = ovcP
// module chunks = 51